import { useRouter } from 'next/router';
import { useCallback, useMemo } from 'react';
import { isSkillup } from '../config/project/project';
import useUpdateRouter from './updateRouter';
import { useRegion } from '../providers/regionProvider';

const useClearAllFilters = (
  page: 'careers' | 'training' | 'open-jobs' | 'careerguide',
  resetState: () => void,
) => {
  const router = useRouter();
  const { updateRouter } = useUpdateRouter();
  const {
    region: { slug },
  } = useRegion();
  const pathname = useMemo(
    () => (isSkillup ? `/${slug}/${page}` : `/${page}`),
    [slug],
  );

  const clearAllFilters = useCallback(() => {
    const { sortBy } = router.query;
    updateRouter({
      pathname,
      query: {
        ...(sortBy ? { sortBy } : {}),
      },
    });
    resetState();
  }, [router, pathname]);

  return { clearAllFilters };
};

export default useClearAllFilters;
